<div class="body">
  <div [ngClass]="thumbClass">
    <div *ngFor="let document of documents; trackBy: trackByIndex" class="thumbnails">Thumbnail {{ document }}</div>
  </div>
  <div class="coding-con">
    <div [ngClass]="chartConClass">
      <div [ngClass]="chartClass">
        <div *ngFor="let document of documents; trackBy: trackByIndex" class="chart">Chart {{ document }}</div>
      </div>
      <div [ngClass]="expandClass">
        <div *ngFor="let document of documents; trackBy: trackByIndex" class="expand">Expanded Thumbnail {{ document }}</div>
      </div>
    </div>
    <div class="data-con">
      <div class="data">Data Entry</div>
    </div>
  </div>
</div>
<div class="nav">
  <app-button class="button" text="Back" classes="small" routerLink="/toolbox"></app-button>
  <app-button class="button" text="expand" classes="small" (onClick)="expand()"></app-button>
  <app-button class="button" text="collapse" classes="small" (onClick)="collapse()"></app-button>
</div>